import { makeStyles } from '@mui/styles';

export default makeStyles({
  container: {
    height: '20px',
    marginBottom: '20px',
  },
});
